import posthog from 'posthog-js'
import { ClickTrackingEventTypes } from '@/generated/enums'
/**
 * A wrapper around PostHog capture to include common properties across all events.
 * @param eventName - The name of the analytics event.
 * @param extraProps - Any additional properties specific to this event.
 */

export function useClickTracker() {
  return (eventName: ClickTrackingEventTypes, extraProps?: Record<string, any>) => {
    posthog.capture(eventName, {
      properties: {
        ...extraProps,
      },
    })
  }
}
